/**
 * Mesure d'audience, par Cloudflare Web Analytics.
 *
 * Choisi pour une raison précise : il ne pose aucun cookie et ne collecte
 * aucune donnée personnelle. Il n'y a donc **aucun bandeau de consentement à
 * afficher**, ce qui compte doublement ici. D'abord parce que la CNIL exempte
 * la mesure d'audience anonyme du recueil de consentement. Ensuite parce qu'un
 * bandeau à cliquer avant de savoir si l'on peut ouvrir sa fenêtre serait une
 * insulte au service rendu.
 *
 * Le jeton n'est pas dans le dépôt. Il est lu à la compilation depuis
 * `VITE_CF_BEACON_TOKEN`, donc absent en développement, où l'on n'a aucune
 * raison de polluer les statistiques avec ses propres rechargements.
 *
 * Si un jour l'hébergement passe sur Cloudflare Pages et que la mesure
 * d'audience y est activée d'un clic, Cloudflare injecte lui-même la balise :
 * il faudra alors retirer la variable pour ne pas compter deux fois.
 */
const BEACON_URL = 'https://static.cloudflareinsights.com/beacon.min.js';

function readToken(): string | null {
  const raw: unknown = import.meta.env['VITE_CF_BEACON_TOKEN'];
  if (typeof raw !== 'string') return null;
  const token = raw.trim();
  return token.length > 0 ? token : null;
}

export function startAnalytics(): void {
  const token = readToken();
  if (!token) return;

  // Rien de bloquant : la balise se charge après le premier rendu.
  const script = document.createElement('script');
  script.src = BEACON_URL;
  script.defer = true;
  script.setAttribute('data-cf-beacon', JSON.stringify({ token }));
  document.head.append(script);
}
